import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06b2831a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard ff-bottom-fixed-cta" }
const _hoisted_2 = { class: "profile-creation-wizard__container" }
const _hoisted_3 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_4 = { class: "profile-creation-wizard__content" }
const _hoisted_5 = { class: "headline-section__tag profile-tag responsive-content" }
const _hoisted_6 = { class: "profile-tag__content" }
const _hoisted_7 = { class: "profile-creation-wizard__content-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!
  const _component_step_mobile_header = _resolveComponent("step-mobile-header")!
  const _component_headline_selection = _resolveComponent("headline-selection")!
  const _component_step_actions = _resolveComponent("step-actions")!
  const _component_headline_side = _resolveComponent("headline-side")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_joy_progress_bar, { percentage: _ctx.progressPercentage }, null, 8, ["percentage"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_step_mobile_header, {
            "step-name": _ctx.stepName,
            "show-button-previous": false
          }, null, 8, ["step-name"]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$msg('profile.creation.predictor.wizard.details.headline.tagline')), 1)
          ]),
          _createVNode(_component_headline_selection, {
            title: _ctx.$msg('profile.creation.predictor.wizard.details.headline.title'),
            "subtitle-help": _ctx.$msg('profile.creation.predictor.wizard.details.headline.help'),
            onHeadlineKeypressEnter: _ctx.headlineKeypressEnter
          }, null, 8, ["title", "subtitle-help", "onHeadlineKeypressEnter"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_joy_progress_bar, {
            percentage: _ctx.progressPercentage,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(_component_step_actions, {
            "step-name": _ctx.stepName,
            "is-disabled-button-next": !_ctx.hasValidFieldPart,
            "show-button-previous": false,
            "onClick:next": _ctx.goNext
          }, null, 8, ["step-name", "is-disabled-button-next", "onClick:next"])
        ])
      ]),
      _createVNode(_component_headline_side)
    ])
  ]))
}